import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Check if already logged in
  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      verifyToken(token);
    }
  }, []);

  const verifyToken = async (token) => {
    try {
      const response = await fetch(`${API_URL}/api/admin/verify`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      if (data.valid) {
        navigate('/admin/dashboard');
      }
    } catch (err) {
      localStorage.removeItem('admin_token');
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials)
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('admin_token', data.token);
        localStorage.setItem('admin_username', data.username);
        navigate('/admin/dashboard');
      } else {
        setError(data.detail || 'Invalid credentials');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #2E221A 0%, #4A3324 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: '#FAF7F3',
        padding: '48px',
        maxWidth: '420px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <h1 style={{
            fontFamily: 'Cinzel, serif',
            fontSize: '1.8rem',
            color: '#2E221A',
            letterSpacing: '0.1em',
            marginBottom: '8px'
          }}>AMATYA</h1>
          <p style={{
            fontFamily: 'Lato, sans-serif',
            fontSize: '0.8rem',
            color: '#725b47',
            letterSpacing: '0.15em',
            textTransform: 'uppercase'
          }}>Admin Portal</p>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.7rem',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: '#725b47',
              display: 'block',
              marginBottom: '8px'
            }}>Username</label>
            <input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              data-testid="admin-username"
              style={{
                width: '100%',
                padding: '14px 16px',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.95rem',
                border: '1px solid rgba(139,69,19,0.3)',
                background: '#fff',
                color: '#2E221A',
                outline: 'none'
              }}
              placeholder="Enter username"
              required
            />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label style={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.7rem',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              color: '#725b47',
              display: 'block',
              marginBottom: '8px'
            }}>Password</label>
            <input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              data-testid="admin-password"
              style={{
                width: '100%',
                padding: '14px 16px',
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.95rem',
                border: '1px solid rgba(139,69,19,0.3)',
                background: '#fff',
                color: '#2E221A',
                outline: 'none'
              }}
              placeholder="Enter password"
              required
            />
          </div>

          {error && (
            <div style={{
              padding: '12px',
              background: 'rgba(211,47,47,0.1)',
              border: '1px solid rgba(211,47,47,0.3)',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              <span style={{ fontFamily: 'Lato, sans-serif', fontSize: '0.85rem', color: '#C62828' }}>{error}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            style={{
              width: '100%',
              padding: '16px',
              fontFamily: 'Lato, sans-serif',
              fontSize: '0.8rem',
              letterSpacing: '0.15em',
              textTransform: 'uppercase',
              background: loading ? '#a48c6f' : '#8B4513',
              color: '#FAF7F3',
              border: 'none',
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
